;(function () {
  'use strict'

  angular
    .module('contrast.libraries')
    .factory('LibrariesService', LibrariesService)

  function LibrariesService(
    $rootScope,
    $q,
    sendLibService,
    BugtrackerService,
    ErrorService,
    LibraryFactory,
    logger
  ) {
    'ngInject'

    return {
      buildLibraryOutdatedBreakdown: buildLibraryOutdatedBreakdown,
      downloadFile: downloadFile,
      findCommonApplication: findCommonApplication,
      openSendToBugtracker: openSendToBugtracker,
      convertToBaseInfo: convertToBaseInfo,
      sendToBugtracker: sendToBugtracker
    }

    function downloadFile(params) {
      var body = _createExportFilterRequestBody(params)
      _broadcastExport({
        redirectUrl: LibraryFactory.getExportAllUrl(),
        redirectMethod: 'POST',
        redirectData: body
      })
    }

    function _createExportFilterRequestBody(params) {
      if (!angular.isObject(params)) {
        params = {}
      }

      var body = [],
        request = _createFilterRequest(params)

      angular.forEach(request, function (value, key) {
        var i = 0

        if (angular.isArray(value)) {
          for (; i < value.length; i++) {
            body.push({ name: key, value: value[i] })
          }
        } else {
          body.push({ name: key, value: value })
        }
      })

      return body
    }

    function _createFilterRequest(params) {
      if (!angular.isObject(params)) {
        params = {}
      }
      var request = {}

      if (params.librariesObjects) {
        request.hashes = _convertLibrariesToHashes(params.librariesObjects)
      }

      if (params.searchKeywords) {
        request.q = params.searchKeywords
      }

      if (params.subfilters) {
        angular.extend(request, params.subfilters)
      }

      if (params.quickFilter) {
        request.quickFilter = params.quickFilter
      }

      if (params.exportFileType) {
        request.exportFileType = params.exportFileType
      }

      return request
    }

    function _convertLibrariesToHashes(libraries) {
      return libraries.map(function (lib) {
        return lib.hash
      })
    }

    function _broadcastExport(data) {
      $rootScope.$broadcast('libraries:export', data)
    }

    function buildLibraryOutdatedBreakdown(libs) {
      var dataMonths = []
      var dataYears = []
      var unknown = { label: 'Unknown', value: 0 }
      var upToDate = { label: 'Up-to-date', value: 0 }
      var item
      angular.forEach(libs, function (lib) {
        var monthsApart = lib.months_outdated
        var count = lib.count
        if (monthsApart < 0) {
          unknown.value += count
        } else if (monthsApart == 0) {
          upToDate.value += count
        } else {
          if (typeof dataMonths[monthsApart] !== 'undefined') {
            dataMonths[monthsApart].value += count
          } else {
            item = { label: '' + monthsApart, value: count }
            dataMonths[monthsApart] = item
          }

          var yearsApart = Math.min(Math.floor(monthsApart / 12))
          if (typeof dataYears[yearsApart] !== 'undefined') {
            dataYears[yearsApart].value += count
          } else {
            item = { label: '' + yearsApart, value: count }
            dataYears[yearsApart] = item
          }
        }
      })

      if (upToDate.value > 0) {
        dataMonths.push(upToDate)
        dataYears.push(upToDate)
      }

      var i

      if (dataYears.length > 2) {
        for (i = 0; i < dataYears.length; i++) {
          item = dataYears[i]
          if (typeof item === 'undefined') {
            dataYears[i] = { label: '' + i, value: 0 }
          }
        }
        if (unknown.value > 0) {
          dataYears.push(unknown)
        }

        return { data: dataYears, isMonths: false }
      } else {
        for (i = 0; i < dataMonths.length; i++) {
          item = dataMonths[i]
          if (typeof item === 'undefined') {
            dataMonths[i] = { label: '' + i, value: 0 }
          }
        }
        if (unknown.value > 0) {
          dataMonths.push(unknown)
        }

        return { data: dataMonths, isMonths: true }
      }
    }

    function findCommonApplication(libraries) {
      if (libraries.length > 0) {
        var applicationsIds = _.map(libraries[0].apps, 'app_id')
        var i
        for (i = 1; i < libraries.length; i++) {
          applicationsIds = _.intersection(
            applicationsIds,
            _.map(libraries[i].apps, 'app_id')
          )
        }
        return applicationsIds
      }

      return []
    }

    function openSendToBugtracker(libs, commonApps, callback) {
      BugtrackerService.getBugtrackersByApplications(commonApps)
        .then(function (bugtrackers) {
          return sendLibService.open({
            resolve: {
              libraries: function () {
                return libs
              },
              bugtrackers: function () {
                return bugtrackers
              }
            }
          }).result
        })
        .then(callback)
        .catch(ErrorService.processError)
    }

    function convertToBaseInfo(libraries) {
      var test = libraries.map(function (lib) {
        return { sha1: lib.hash, language: lib.app_language }
      })
      return test
    }

    function sendToBugtracker(bugtrackerId, data) {
      return LibraryFactory.sendToBugtracker(bugtrackerId, data)
        .then(function (response) {
          var data = response.data
          if (data.success_msg) {
            logger.logSuccess(data.success_msg)
          }
          return response
        })
        .catch(function (response) {
          var data = response.data
          var returnVal = {
            errorCode: data.error_code,
            errorMsgs: []
          }
          if (data.bugtracker_errors) {
            for (var i = 0; i < data.bugtracker_errors.length; i++) {
              returnVal.errorMsgs.push(data.bugtracker_errors[i])
            }
          }
          if (data.fail_msg) {
            logger.logError(data.fail_msg)
            // This is intentional
            if (data.success_msg) {
              logger.logSuccess(data.success_msg)
            }
          } else {
            return ErrorService.processError(response)
          }
          return $q.reject(returnVal)
        })
    }
  }
})()
